import { useI18n } from '../../contexts/I18nContext';
import { Shield, Building2, Users, TrendingUp, CheckCircle2, FileText, Award, Target, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';

// Team member photos
const TEAM_PHOTOS = {
  fernando: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/iezwaqs2_WhatsApp%20Image%202026-04-09%20at%203.32.28%20PM.jpeg',
  jorge: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/g91yd663_WhatsApp%20Image%202026-04-09%20at%203.29.43%20PM%20%282%29.jpeg',
  antonio: 'https://customer-assets.emergentagent.com/job_79b1230d-349d-4e3f-a2d7-9f6948366d30/artifacts/csbtf81l_WhatsApp%20Image%202026-04-09%20at%203.37.33%20PM.jpeg'
};

const AboutPage = () => {
  const { t } = useI18n();

  const values = [
    {
      icon: Shield,
      title: 'Integridad',
      description: 'Actuamos con honestidad y transparencia en cada transacción y comunicación.'
    },
    {
      icon: Building2,
      title: 'Excelencia',
      description: 'Buscamos los mejores activos y estructuras para nuestros inversionistas.'
    },
    {
      icon: Users,
      title: 'Compromiso',
      description: 'Nuestro éxito está alineado con el éxito de nuestros inversionistas.'
    },
    {
      icon: TrendingUp,
      title: 'Disciplina',
      description: 'Seguimos procesos rigurosos de análisis y due diligence en cada oportunidad.'
    },
  ];

  const teamDirectivo = [
    {
      name: 'Fernando Madrid',
      role: 'Chief Executive Officer (CEO)',
      photo: TEAM_PHOTOS.fernando,
      bio: `Fernando Madrid cuenta con una trayectoria enfocada en la estructuración de inversión y desarrollo inmobiliario, con especialización en la identificación, análisis y ejecución de oportunidades dentro del sector real estate.

A lo largo de su carrera ha participado en la estructuración y desarrollo de proyectos inmobiliarios, así como en la obtención de capital para su ejecución, integrando procesos de originación, análisis financiero y diseño de vehículos de inversión.

Su experiencia abarca activos inmobiliarios urbanos, destacando por su capacidad para identificar oportunidades de valor, estructurar esquemas eficientes de financiamiento y ejecutar estrategias orientadas a maximizar rentabilidad bajo un enfoque disciplinado de control de riesgo.

Dentro de SilverBrick, lidera la originación de oportunidades, la estructuración de inversiones y la coordinación estratégica de proyectos, asegurando la alineación entre ejecución operativa y objetivos financieros.`
    },
    {
      name: 'Gabriel Antonio Lascurain',
      role: 'Chief Commercial Officer (CCO)',
      photo: TEAM_PHOTOS.antonio,
      bio: `Licenciado en Contaduría por la Universidad Simón Bolívar, con estudios de posgrado en la Universidad Pontificia Comillas de Madrid.

Cuenta con más de 25 años de experiencia en dirección empresarial, desarrollo comercial y expansión de negocios, participando en la consolidación y crecimiento de diversas organizaciones.

Es gestor certificado de riesgos y especialista en planeación estratégica, con una sólida trayectoria en la estructuración de modelos comerciales eficientes y sostenibles.

Dentro de SilverBrick, lidera la estrategia comercial del fondo, enfocándose en la expansión, posicionamiento y consolidación de oportunidades, así como en el fortalecimiento de relaciones estratégicas clave.`
    },
    {
      name: 'Jorge Esteban Salcido Toledo',
      role: 'Presidente del Consejo',
      photo: TEAM_PHOTOS.jorge,
      bio: `Ingeniero Industrial por la Universidad Iberoamericana, con formación especializada en negocios e inversiones inmobiliarias a través de múltiples diplomados y certificaciones de la Asociación Mexicana de Profesionales Inmobiliarios (AMPI), así como certificación federal en comercialización inmobiliaria.

Cuenta con una trayectoria sólida en el sector inmobiliario, desarrollo de negocios y estructuración de proyectos, destacando por su participación en la dirección, comercialización y expansión de iniciativas dentro del sector real estate.

Es socio fundador y Presidente Nacional de la Unión de Profesionales Inmobiliarios de México (UPIM), organización que ha impulsado la profesionalización del sector a nivel nacional.

Asimismo, se desempeña como Director Ejecutivo de la desarrolladora "Échale Tu Casa", una de las vivienderas sociales más relevantes en México, con más de 40 años de trayectoria y más de 250,000 soluciones de vivienda desarrolladas en el país.`
    }
  ];

  return (
    <div className="min-h-screen bg-background pt-20">
      {/* Hero */}
      <section className="section-spacing border-b border-border">
        <div className="container-app">
          <div className="max-w-3xl">
            <p className="caption mb-4">Nosotros</p>
            <h1 className="heading-1 mb-6">Construyendo Patrimonio con Disciplina</h1>
            <p className="body-lg">
              Silver Brick Development es un fondo de inversión inmobiliaria enfocado en generar rendimientos atractivos 
              a través de oportunidades cuidadosamente seleccionadas y estructuradas con rigor institucional.
            </p>
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="relative h-[50vh] min-h-[400px]">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url(https://images.unsplash.com/photo-1670383050616-682df7d57b22?q=80&w=2670&auto=format&fit=crop)`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
        </div>
      </section>

      {/* Values */}
      <section className="section-spacing border-b border-border">
        <div className="container-app">
          <div className="text-center mb-16">
            <p className="caption mb-4">Nuestros Valores</p>
            <h2 className="heading-2">Principios que Nos Guían</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="card-premium text-center">
                <div className="h-16 w-16 rounded-full bg-primary/10 mx-auto mb-6 flex items-center justify-center">
                  <value.icon className="h-8 w-8 text-primary" strokeWidth={1} />
                </div>
                <h3 className="text-lg font-medium mb-3">{value.title}</h3>
                <p className="text-sm text-muted-foreground">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Differentiators */}
      <section className="section-spacing bg-muted/30">
        <div className="container-app">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="caption mb-4">¿Por Qué SilverBrick?</p>
              <h2 className="heading-2 mb-6">Diferenciadores Clave</h2>
              <div className="space-y-4">
                {[
                  'Selección rigurosa de activos con criterios institucionales',
                  'Estructuras de inversión transparentes y alineadas',
                  'Due diligence exhaustivo y control de riesgo disciplinado',
                  'Comunicación constante y reportes detallados',
                  'Equipo con experiencia comprobada en real estate',
                  'Acceso a oportunidades típicamente reservadas para grandes capitales'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                    <span className="text-muted-foreground">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="card-premium">
              <div className="space-y-6">
                <div>
                  <p className="text-4xl font-light text-primary mb-1">+50</p>
                  <p className="text-sm text-muted-foreground">Proyectos Completados</p>
                </div>
                <div>
                  <p className="text-4xl font-light text-primary mb-1">+500,000</p>
                  <p className="text-sm text-muted-foreground">m² Desarrollados</p>
                </div>
                <div>
                  <p className="text-4xl font-light text-primary mb-1">15+</p>
                  <p className="text-sm text-muted-foreground">Años de Experiencia</p>
                </div>
                <div>
                  <p className="text-4xl font-light text-primary mb-1">+250,000</p>
                  <p className="text-sm text-muted-foreground">Soluciones de Vivienda</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== EQUIPO DIRECTIVO Y CONSEJO ESTRATÉGICO ==================== */}
      <section className="section-spacing border-b border-border" id="equipo-directivo">
        <div className="container-app">
          {/* Section Header */}
          <div className="text-center mb-6">
            <p className="caption mb-4">Equipo Directivo y Consejo Estratégico</p>
            <h2 className="heading-2 mb-4">Un equipo con visión, ejecución y experiencia institucional</h2>
          </div>
          
          {/* Intro Text */}
          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="body-lg text-muted-foreground">
              En SilverBrick Development, la fortaleza del fondo radica en la experiencia, visión estratégica 
              y capacidad de ejecución de su equipo directivo y consejo.
            </p>
            <p className="body-lg text-muted-foreground mt-4">
              Cada uno de sus integrantes aporta un enfoque especializado en estructuración de inversión, 
              desarrollo inmobiliario, gestión de riesgo y expansión comercial, consolidando una plataforma 
              sólida orientada a la generación de valor sostenible para sus inversionistas.
            </p>
          </div>

          {/* Team Members */}
          <div className="space-y-24">
            {teamDirectivo.map((member, index) => (
              <div 
                key={index} 
                className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Photo */}
                <div className={`lg:col-span-4 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative aspect-[3/4] max-w-sm mx-auto lg:mx-0">
                    {member.photo ? (
                      <img 
                        src={member.photo} 
                        alt={member.name}
                        className="w-full h-full object-contain rounded-lg shadow-2xl"
                      />
                    ) : (
                      <div className="w-full h-full bg-muted rounded-lg flex items-center justify-center">
                        <div className="text-center p-8">
                          <Users className="h-20 w-20 text-muted-foreground mx-auto mb-4" strokeWidth={1} />
                          <p className="text-muted-foreground text-sm">Foto próximamente</p>
                        </div>
                      </div>
                    )}
                    {/* Decorative element */}
                    <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-primary/20 rounded-lg -z-10" />
                  </div>
                </div>

                {/* Bio */}
                <div className={`lg:col-span-8 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-2xl md:text-3xl font-light tracking-tight mb-2">
                        {member.name}
                      </h3>
                      <p className="text-primary font-medium tracking-wide uppercase text-sm">
                        {member.role}
                      </p>
                    </div>
                    
                    <div className="w-16 h-px bg-primary/30" />
                    
                    <div className="space-y-4 text-muted-foreground leading-relaxed">
                      {member.bio.split('\n\n').map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                    </div>

                    {/* Highlights based on role */}
                    <div className="pt-4">
                      {member.role.includes('CEO') && (
                        <div className="flex flex-wrap gap-3">
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Target className="h-3 w-3" /> Originación de Oportunidades
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Briefcase className="h-3 w-3" /> Estructuración de Inversiones
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <TrendingUp className="h-3 w-3" /> Control de Riesgo
                          </span>
                        </div>
                      )}
                      {member.role.includes('CCO') && (
                        <div className="flex flex-wrap gap-3">
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Award className="h-3 w-3" /> 25+ Años de Experiencia
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Shield className="h-3 w-3" /> Gestor Certificado de Riesgos
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Target className="h-3 w-3" /> Estrategia Comercial
                          </span>
                        </div>
                      )}
                      {member.role.includes('Presidente') && (
                        <div className="flex flex-wrap gap-3">
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Award className="h-3 w-3" /> Presidente Nacional UPIM
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <Building2 className="h-3 w-3" /> Director Échale Tu Casa
                          </span>
                          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 text-primary text-xs font-medium rounded-full">
                            <FileText className="h-3 w-3" /> Certificación AMPI
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Track Record */}
      <section className="section-spacing bg-muted/20">
        <div className="container-app">
          <div className="text-center mb-12">
            <p className="caption mb-4">Trayectoria Comprobada</p>
            <h2 className="heading-2">Resultados que Respaldan Nuestra Experiencia</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="p-6">
              <p className="text-4xl md:text-5xl font-light text-primary mb-2">+50</p>
              <p className="text-sm text-muted-foreground">Proyectos Completados</p>
            </div>
            <div className="p-6">
              <p className="text-4xl md:text-5xl font-light text-primary mb-2">+500K</p>
              <p className="text-sm text-muted-foreground">m² Desarrollados</p>
            </div>
            <div className="p-6">
              <p className="text-4xl md:text-5xl font-light text-primary mb-2">+250K</p>
              <p className="text-sm text-muted-foreground">Soluciones de Vivienda</p>
            </div>
            <div className="p-6">
              <p className="text-4xl md:text-5xl font-light text-primary mb-2">15+</p>
              <p className="text-sm text-muted-foreground">Años de Experiencia</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-spacing bg-primary text-primary-foreground">
        <div className="container-app text-center">
          <h2 className="heading-2 mb-6">¿Listo para Invertir?</h2>
          <p className="body-lg text-primary-foreground/70 max-w-2xl mx-auto mb-8">
            Únase a nuestra red de inversionistas y acceda a oportunidades inmobiliarias de clase institucional.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register">
              <Button className="bg-background text-foreground hover:bg-background/90 rounded-sm px-8 py-4 h-auto text-sm uppercase tracking-wide font-medium">
                Crear Cuenta
              </Button>
            </Link>
            <Link to="/contacto">
              <Button variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 rounded-sm px-8 py-4 h-auto text-sm uppercase tracking-wide font-medium">
                Contactar
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
